import React, {useContext} from "react";
import {
    DamageLocation,
    DamageModelWithDirection,
    DamageType,
    DamageTypeFirstLetter,
    EquipmentType
} from "../../../../models/tcr";
import {SideType} from "../../../../models/transport";
import TcrUtils from "../../../../../helpers/tcrUtils";
import {storesContext} from "../../../../../common/stores/stores";
import {Text, Circle, Font} from "@react-pdf/renderer";
import OpenSansRegular from "../../../../../statics/typos/openSansRegular.ttf";
import OpenSansSemiBold from "../../../../../statics/typos/openSansSemiBold.ttf";
import OpenSansBold from "../../../../../statics/typos/openSansBold.ttf";

Font.register({
    family: "OpenSans",
    format: "truetype",
    src: OpenSansRegular
});
Font.register({
    family: "OpenSansSemiBold",
    format: "truetype",
    src: OpenSansSemiBold
});
Font.register({
    family: "OpenSansBold",
    format: "truetype",
    src: OpenSansBold
});

interface MarkDamagesOnTrailerPrintoutProps {
    sideType: SideType;
    equipmentType: EquipmentType;
    damageLocation?: DamageLocation | null;
    fontSize?: number;
    textY?: string;
}

export default function MarkDamagesOnTrailerPrintout(props: MarkDamagesOnTrailerPrintoutProps): React.ReactElement {
    const tcrStore = useContext(storesContext).tcrStore;
    const damages = tcrStore.damages;


    const markDamages = damages.filter((damage) => {
        if (props.damageLocation) {
            return damage.equipmentType === props.equipmentType &&
                damage.sideType === props.sideType &&
                damage.damageLocation === props.damageLocation;
        } else {
            return damage.equipmentType === props.equipmentType &&
                damage.sideType === props.sideType;
        }
    });

    if (markDamages && markDamages.length > 0) {
        return (
            <>
                <Circle
                    r="25"
                    cx="137"
                    cy="39"
                    fill="#fff"
                    strokeWidth="1.25736"
                    stroke="#000"
                >
                    <Text
                        x="120"
                        y={props.textY ? props.textY : "44.973991"}
                        fill="#000"
                        style={{
                            fontSize: props.fontSize ? props.fontSize : 13,
                            fontFamily: "OpenSans"
                        }}
                    >
                        {generateShortTcrCode(markDamages)}
                    </Text>
                </Circle>
            </>
        );
    }  else return <></>;

    function generateShortTcrCode(damages: DamageModelWithDirection[]) {
        let result = "";
        damages.map((damage) => {
            if (!damage.equipmentType || !damage.damageType || !TcrUtils.getEquipmentNumber(damage.equipmentType)) {
                result = "";
            }

            result = `${damagesTypeFirstLetter(damages)}${TcrUtils.getEquipmentNumber(damage.equipmentType)}`;
        });

        return result;
    }

    function damagesTypeFirstLetter(damages: DamageModelWithDirection[]) {
        let result = "";
        damages.map((damage) => {
            if (!damage.damageType) {
                result = "";
            }

            result += DamageTypeFirstLetter[damage.damageType as DamageType];
        });

        return result;
    }
}
